export const LogoMark = ({ className = "w-10 h-10" }) => (
    <img
        src="/logo.jpg"
        alt="Naagarjun Power Fiber logo"
        className={`${className} object-contain bg-white`}
        data-testid="logo-mark"
    />
);

export const Logo = ({ compact = false }) => (
    <span className="flex items-center gap-3">
        <LogoMark className={compact ? "w-9 h-9" : "w-11 h-11"} />
        <span className="flex flex-col leading-none">
            <span
                className={`font-display font-semibold uppercase tracking-wide text-zinc-50 ${
                    compact ? "text-base" : "text-lg"
                }`}
            >
                Naagarjun
            </span>
            <span className="font-mono text-[9px] uppercase tracking-[0.42em] text-safety mt-1">
                Power Fiber
            </span>
        </span>
    </span>
);

export default Logo;